import { Palette } from '@mui/material/styles/createPalette';

import { Tokens } from '../Theme';

export enum CounterSize {
  large = 'large',
  medium = 'medium',
  small = 'small',
  extraSmall = 'extraSmall',
}

export type SizeScheme = {
  [key in keyof typeof CounterSize]: {
    height: number;
  };
};

export enum CounterColor {
  green = 'green',
  orange = 'orange',
  red = 'red',
  blue = 'blue',
  purple = 'purple',
  black = 'black',
  white = 'white',
}

export type ColorScheme = {
  [key in keyof typeof CounterColor]: (palette: Palette) => string;
};

export enum CounterBackgroundColor {
  gray = 'gray',
  green = 'green',
  lightGreen = 'lightGreen',
  orange = 'orange',
  lightOrange = 'lightOrange',
  red = 'red',
  lightRed = 'lightRed',
  blue = 'blue',
  lightBlue = 'lightBlue',
  purple = 'purple',
  lightPurple = 'lightPurple',
  violet = 'violet',
  white = 'white',
}

export type BackgroundColorScheme = {
  [key in keyof typeof CounterBackgroundColor]: (
    palette: Palette,
    tokens: Tokens,
  ) => string;
};
